import React, { useState } from 'react';

import './styles.css';

import loadTextTest from '../../../../functions/loadTextTest';
import convertAge from '../../../../functions/convertAge';

import UserPhoto from '../../../../components/UserPhoto';
import { Link, useHistory } from 'react-router-dom';
import { FaAngleDown, FaAngleUp, FaPen, FaTrash } from 'react-icons/fa';
import coachServices from '../../../../services/academy/coachServices';

export default function CoachProfileCard(props) {
    const [showMore, setShowMore] = useState(false);
    const history = useHistory();

    let name;
    if (props.coachInfos && props.coachInfos.nome && props.coachInfos.nome)
        name = `${props.coachInfos.nome} ${props.coachInfos.sobrenome}`;
    else
        name = null;

    return (
        <div className='coach-page-card' id='card-profile'>
            <UserPhoto src={props.coachInfos && props.coachInfos.foto ? props.coachInfos.foto : null}/>
            <div className='coach-card-profile-options'>
                <div className='coach-card-profile-infos'>
                    <div>
                        <h4><b>{loadTextTest(name)}</b></h4>
                        {
                            props.coachInfos.user && !(props.coachProfileMode || props.coachMode)  ?
                            <span><p className={props.coachInfos.user.ativo ? "active" : "inactive"}>{props.coachInfos.user.ativo ? "Ativo" : "Inativo"}</p></span>
                            :
                            null
                        }
                    </div>
                    <p><b>ID: </b>{props.coachInfos.id}</p>
                    <p><b>Idade: </b>{loadTextTest(convertAge(props.coachInfos.data_nascimento))}</p>
                    {
                        showMore ?
                            <>
                                {props.coachInfos.genero ? <p><b>Gênero: </b>{props.coachInfos.genero}</p> : []}
                                {props.coachInfos.user && props.coachInfos.user.email ? <p><b>Email: </b>{props.coachInfos.user.email}</p> : []}
                                {props.coachInfos.telefone ? <p><b>Telefone: </b>{props.coachInfos.telefone}</p> : []}
                                {props.coachInfos.cidade ? <p><b>Cidade: </b>{props.coachInfos.cidade}</p> : []}
                                {props.coachInfos.estado ? <p><b>Estado: </b>{props.coachInfos.estado}</p> : []}
                                {props.coachInfos.bairro ? <p><b>Bairro: </b>{props.coachInfos.bairro}</p> : []}
                                {props.coachInfos.logradouro ? <p><b>Endereço: </b>{props.coachInfos.logradouro}</p> : []}
                            </>
                            : []
                    }
                    <button onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Menos informações" : "Mais informações"} {showMore ? <FaAngleUp /> : <FaAngleDown />}
                    </button>
                </div>

                {
                    props.coachProfileMode || props.coachMode ?
                        [] :
                        <div className='coach-card-buttons-container'>
                            <Link className='button' to={props.isAdmin ? `/admin/academias/${props.academyId}/professores/${props.coachInfos.id}/editar` : `/academia/professores/${props.coachInfos.id}/editar`}>Editar professor<FaPen /></Link>
                            <button onClick={()=> props.deleteCoach(props.coachInfos.id, name)} className='button red'>Deletar Professor<FaTrash/></button>
                        </div>
                }

            </div>
        </div>
    )
}